import { createStructuredSelector } from "reselect";
import {
    SCHEDULE_MTO_EVENT_LIST,
    SCHEDULE_MTO_EVENT_LIST_SUCCESS,
    SCHEDULE_MTO_EVENT_LIST_ERROR,
    SCHEDULE_MTO_DETAIL_EVENT_LIST,
    SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS,
    SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR,
    SCHEDULE_MTO_REMINDER,
    SCHEDULE_MTO_REMINDER_SUCCESS,
    SCHEDULE_MTO_REMINDER_ERROR
} from "../../actions";

export const NAME = 'scheduleMto';

export const ScheduleMtoEventList = (data) => ({
    type: SCHEDULE_MTO_EVENT_LIST,
    payload: data
});

export const ScheduleMtoEventListSuccess = (data) => ({
    type: SCHEDULE_MTO_EVENT_LIST_SUCCESS,
    payload: data
});

export const ScheduleMtoEventListError = (error) => ({
    type: SCHEDULE_MTO_EVENT_LIST_ERROR,
    payload: error
});

export const ScheduleMtoDetailEventList = (data) => ({
    type: SCHEDULE_MTO_DETAIL_EVENT_LIST,
    payload: data
});

export const ScheduleMtoDetailEventListSuccess = (data) => ({
    type: SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS,
    payload: data
});

export const ScheduleMtoDetailEventListError = (error) => ({
    type: SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR,
    payload: error
});


export const ScheduleMtoReminder = (data) => ({
    type: SCHEDULE_MTO_REMINDER,
    payload: data
});

export const ScheduleMtoReminderSuccess = (data) => ({
    type: SCHEDULE_MTO_REMINDER_SUCCESS,
    payload: data
});

export const ScheduleMtoReminderError = (error) => ({
    type: SCHEDULE_MTO_REMINDER_ERROR,
    payload: error
});


const scheduleMto = (state) => state[NAME];

export const ScheduleMtoSelector = createStructuredSelector({
    scheduleMto
}) 
